import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";
import * as VO from "Data/VO";
import { Button } from "GameObjects/Button";

export class HomeButton extends Button {
    constructor() {
        super(() => this.onClick(), "exit-button", Constants.SPRITESHEET_UI, VO.UI.UI9, "ui_click");
    }

    protected onClick() {
        PubSub.publishSync(Topics.HOME_BUTTON_PRESSED, this);
    }
}
